/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import UploadFileIcon from '@mui/icons-material/UploadFile'; //added on 01.04.2023
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import TableSummarize from "../components/TableSummarize";
import { toast } from "react-toastify";
import Axios from 'axios';
import * as XLSX from 'xlsx';
import { orange } from '@mui/material/colors';
import { useLocation, useNavigate } from 'react-router-dom'

import ToPrintPageSummarize from '../components/ToPrintPageSummarize'

export default function PageSummarize() {

  const courId = localStorage.getItem('AccessRights').substring(11,14)
  const token = JSON.parse(localStorage.getItem('token')) 
  const Access = localStorage.getItem('Access')
// console.log(courId)
  const location = useLocation();
  const navigate = useNavigate()

  const [classNo, setClassno] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSeminar, setSelectedSeminar] = useState("0");
  const [isSubmit, setIssubmit] = useState(false);
  const [btnUpload, setBtnupload] = useState(false);
  const [numSubject, setNumSubject] = useState([]);
  const [dropdownitems, setDropDownList] = useState([]);

  const [selected, setSelected] = useState([]);
  const courseNum = numSubject.length

  // useEffect(() => {
  //   if (isSubmit) {
  //     // const idTokenResult = localStorage.token;
  //     Axios.get(process.env.REACT_APP_API + `/result/course/${selectedClass}/seminar/${selectedSeminar}/${courId}?token=${token}`)
  //     .then((res) => {
  //       setSelected(res.data);  
  //      // console.log(res.data);    
  //    })
  //    .catch((err) => {
  //     if(err.response.status === 400) {
  //       toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
  //       localStorage.clear();
  //       navigate('/')
  //     } else {
  //       console.log("err: ", err.response.data)
  //     }
  //    });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isSubmit]);

  /*--------------- get data to create dropdown list ---------------*/
  useEffect(() => {
    (async () => {
      try {
        const courId = localStorage.getItem('AccessRights').substring(11, 14)
        let resdata = await Axios.get(process.env.REACT_APP_API + `/PageAttribute/${courId}?token=${token}`);
        resdata.data.seminar.unshift('ทุกสัมมนา'); //---added on 26.09.2022
        // console.log("data SeminarList A: ", resdata.data)
        if (resdata.data !== undefined) {
          setDropDownList(resdata.data);
        }
      } catch (err) {
        if(err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate('/')
        } else {
          console.log("err: ", err.response.data)
        }
      }
    })();
  }, [setDropDownList]);

  useEffect(() => {
    loadClass();
    loadSubject2()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadClass = () => {
    Axios.get(process.env.REACT_APP_API + `/education/${courId}?token=${token}`)
      .then((res) => {
        setClassno(res.data);
      })
      .catch((err) => {
        if(err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate('/')
        } else {
          console.log("err: ", err.response.data)
        }
      });

      if (location.state !== null) {
        Axios.get(process.env.REACT_APP_API + `/result/course/${location.state.coursegrp}/seminar/${location.state.seminar}/${courId}?token=${token}`)
        .then((res) => {
          setSelected(res.data.data1);
          // console.log(res.data);
        })
        .catch((err) => {
          if(err.response.status === 400) {
            // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
            localStorage.clear();
            navigate('/')
          } else {
            console.log("err: ", err.response.data)
          }
        });
          // console.log(location.state)
          const { coursegrp, seminar } = location.state
          const backSelectedClass = coursegrp
          const backSelectedSeminar = seminar
          setSelectedClass(backSelectedClass) 
          setSelectedSeminar(backSelectedSeminar)
          setIssubmit(true);
        }
  };

  const handleChangeClass = (event) => {
    setSelectedClass(event.target.value);
    setIssubmit(false);
  };

  const handleChangeSeminar = (event) => {
    setSelectedSeminar(event.target.value);
    setIssubmit(false);
  };

  const onCilckSelect = (classNo, seminarNo) => {
    if (classNo === "" || seminarNo === "") {
      toast.error("กรุณาเลือกรุ่นและสัมมนา");
      setIssubmit(false);
    } else {
      setIssubmit(true);
    }
    return isSubmit;
  };

  const loadSubject2 = async () => {
    Axios.get(process.env.REACT_APP_API + `/subjects2/${courId}?token=${token}`)
      .then((res) => {
       setNumSubject(res.data);  
       // console.log(res.data);    
     })
     .catch((err) => {
      if(err.response.status === 400) {
        toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
        localStorage.clear();
        navigate('/')
      } else {
        console.log("err: ", err.response.data)
      }
     });

  }

  const selectClass = [...new Set(classNo.map((item) => item.CourseGrp))];

  /*-------------------- added on 02042023 ----------------------*/
  const addScoreFromExcelFile = async (xlsxscore) => {
    const token1 = localStorage.getItem('token')
    const courId = localStorage.getItem('AccessRights').substring(11, 14)

    // console.log("data: ", xlsxscore)
    /*---------------- filter to get only completed data to upload -----------------*/
     let acceptlist = xlsxscore.filter(e => {
      return (
        e.persId !== null &&
        e.persId?.length === 10 &&
        e.courId === courId &&
        e.courId !== null &&
        Object.values(e).some(el => el != null)
      );
    });

    // console.log("acceptlist: ",acceptlist.length);
    /*---------------- filter to get only uncompleted data to edit -----------------*/
    let notacceptlist = xlsxscore.filter(e => {
      return (
        e.persId === null ||
        e.persId?.length !== 10 ||
        e.courId !== courId ||
        e.courId === null ||
        //เช็ครหัสหลักสูตรก่อนลง database courId
        Object.values(e).some(el => el == null)
      );
    });

    if (notacceptlist.length === 0) {
      let promise = new Promise((resolve, reject) => {
        acceptlist.map(async e => {
          try {
            let res = await Axios.post(process.env.REACT_APP_API + `/comment?token=${token1}`, e)
            if (res.status === 200) {
              resolve(res.data);
            } else {
              reject(Error(res.statusText));
            }
          } catch (err) {
            if (err.response.status === 400) {
              toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
              localStorage.clear();
              navigate('/')
            } else {
              toast.error(err.response.data.msg);
            }
            console.log('PageSummarize addCommentFromExcelFile failed >>> err : ', err);
          }
          
        });
      }
      );

      toast.promise(promise.then((data) => {
        console.log(data);
      }, (err) => {
        console.log(err);
      }), {
        pending: {
          render: 'กำลังอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูล',
          delay: undefined
        },
        success: {
          render() {
            let persidlist = [];
            notacceptlist.forEach(e => {persidlist.push(e.PersId)});
            return `อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว จำนวน ${acceptlist.length} ข้อมูล มีปัญหาจำนวน ${notacceptlist.length} ข้อมูล`;
          }
        },
        error: {
          render({ data }) {
            this.props.navigate('/');
            localStorage.clear();
            return (`ไม่สามารถอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลได้ เนื่องจาก ${data.message}`);
          }
        }
      }, {
        position: toast.POSITION.TOP_CENTER,
        delay: 3000
      });
    } else {
      toast.error('กรุณาตรวจสอบความถูกต้องของข้อมูลที่ต้องการอัพโหลดอีกครั้ง',
        { position: toast.POSITION.TOP_CENTER }
      );
    }
    // let count = 0;
    // const promises = [];
    // // console.log("data: ", xlsxscore)
    // xlsxscore.map(async e => {
    //   const request = await Axios.post(process.env.REACT_APP_API + `/comment?token=${token1}`, e)
    //     .then(res => {
    //       if (++count === xlsxscore.length) {
    //         toast.success('อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว', {
    //           position: toast.POSITION.TOP_CENTER
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       if(err.response.status === 400) {
    //         toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
    //         localStorage.clear();
    //         navigate('/')
    //       }
    //       console.log('PageSummarize addCommentFromExcelFile failed >>> err : ', err);
    //     })
    //   promises.push(request);
    // });
  }

  /*-------------------- added on 02042023 ----------------------*/
  const formatExcelLayout = (data) => {
    const courId = data[0] === undefined ? localStorage.getItem('AccessRights').substring(11, 14) : data[0]
    // console.log("data: ", data[0])
    let newformat = {
      'commentId': data[3]?.toString() + "-" + courId + "COM",
      'persId': data[3]?.toString(),
      'comment': data[38],
      'courId': courId,
      'insructorId': localStorage.getItem('AccessRights').substring(0, 10)
    }
    return newformat;
  };

  const UploadBtnOnClick = useCallback((e) => {
    let formatxlsxlist = [];
    if (e.target.files.length) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetname = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetname];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false });
        if (reader.readyState === 2) {
          // let ref = XLSX.utils.decode_range(worksheet['!ref']);
          for (let indx = 2; indx < json.length; indx++) {
          // for (let indx = 2; indx <= ref.e.r; indx++) {
            formatxlsxlist.push(formatExcelLayout(json[indx]));
          }
          if (formatxlsxlist) {
            // console.log("res: ",formatxlsxlist)
            addScoreFromExcelFile(formatxlsxlist);
          }
        }
      }
    }
  });

  return (
    <React.Fragment>
      <div className="cotainerDetail">
        <p className="HeadTextMain">ผลการศึกษาสรุปรวม</p>
        <div className="DropdownSelectModel">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            
            <FormControl sx={{ m: 1, minWidth: 100 }}>
              <InputLabel htmlFor="grouped-select">รุ่น</InputLabel>
              <Select
                defaultValue=""
                id="grouped-select"
                label="รุ่น"
                onChange={handleChangeClass}
                value={selectedClass}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {selectClass.map((items, index) => (
                  <MenuItem key={index} value={items}>
                    {items}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 100 }}>
              <InputLabel htmlFor="grouped-select">สัมมนา</InputLabel>
              <Select
                defaultValue=""
                id="grouped-select"
                label="สัมมนา"
                onChange={handleChangeSeminar}
                value={selectedSeminar}
              >
                {dropdownitems.seminar?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={index}
                      sx={{
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                    >
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Button
              onClick={() => onCilckSelect(selectedClass, selectedSeminar)}
              variant="contained"
              sx={{ 
                minWidth: 100, minHeight: 55, m: 1,
                fontFamily: 'THSarabunNew',
                fontWeight: 'bold',
                fontSize: 16,
               }}
               startIcon={<ManageSearchIcon />}
            >
              ตกลง
            </Button>
            <input
              style={{ display: 'none' }}
              id='btn-fileupload'
              multiple
              type='file'
              onChange={(e) => UploadBtnOnClick(e)}
            />
            {Access === 'ผอ.' || Access === 'วัดผล' || Access === 'กรรมวิธี' || Access === 'กรรมวิธีส่วนกลาง' ? (
              <label htmlFor='btn-fileupload'>
              <Button
                variant="contained"
                sx={{
                  minWidth: 100,
                  minHeight: 55,
                  m: 1,
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 16,
                  backgroundColor: orange['A700']
                }}
                startIcon={<UploadFileIcon />}
                component='span'
                onClick={() => {
                  setSelectedClass('');
                  setSelectedSeminar('');
                  setBtnupload(true);
                  setIssubmit(false);
                }}
              >
                อัพโหลดความคิดเห็น
              </Button>
            </label>
            ):('')}
          </Box>
        </div>
        
        
        {/* <Button 
            onClick={handleOnExport} 
            variant="outlined" sx={{minWidth: 100, minHeight: 55 , m:1  }}>Export File
            </Button> */}
        <Container>
        <ToPrintPageSummarize
                dataToPrint={{
                  courseid: courId,
                  coursegrp: selectedClass,
                  seminar: selectedSeminar,
                  isSubmit: isSubmit
                }}
              />
          <TableSummarize
            classNo={selectedClass}
            seminarNo={selectedSeminar}
            isSubmit={isSubmit}
            // courseNum={courseNum}
            btnUpload={btnUpload}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
